import Swiper from 'swiper/dist/js/swiper.min';

export default function () {
  const firstScreen = document.querySelector('.first-screen');
  const sliderWrp = firstScreen ? firstScreen.querySelector('.first-screen__slider') : '';
  const slides = sliderWrp ? [].slice.call(sliderWrp.querySelectorAll('.first-screen__slide')) : false;

  if (sliderWrp) {
    const pagination = firstScreen.querySelector('.first-screen__slider-pagination');
    const slider = {
      options: {
        slidesPerView: 1,
        spaceBetween: 8,
        resistance: true,
        resistanceRatio: 0,
        loop: true,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: pagination,
          bulletClass: 'first-screen__slider-bullet',
          clickable: true,
          bulletActiveClass: 'first-screen__slider-bullet--active',
          renderBullet(index, className) {
            return `<span class="${className}">${index + 1}</span>`;
          },
        },
        on: {
          slideNextTransitionEnd() {
            if (slider.instance !== undefined) {
              slider.reInit();
            }
          },
        },
      },
      instance: undefined,
      reInit() {
        slider.instance.on('slideNextTransitionEnd', () => {
          if (this.instance.realIndex === 0) {
            this.instance.destroy(true, true);
            this.instance = undefined;
            this.instance = new Swiper(sliderWrp, this.options);
          }
        });
      },
    };
    if (slides.length > 1) {
      slider.instance = new Swiper(sliderWrp, slider.options);
    }
  }
}



// WEBPACK FOOTER //
// ./bali-blocks/first-screen/first-screen.js